
import Vue from 'vue';
import { namespace } from 'vuex-class';
import { Component, Emit, Prop } from 'vue-property-decorator';

import PictureComp from '@/components/picture/PictureComp.vue';

import { ClickoutUrl } from '@/helpers/clickout-helper';
import { BuyboxParam } from '@/helpers/offer-helper';
import { contextSportIs, SingleStepContext } from '@/helpers/sports/config';
import { SponsoredClickoutsHelper } from '@/helpers/sponsored-clickouts-helper';

import type { Offer as OfferGraphql } from '@/@types/graphql-types';
import type { WebLocale } from '@/enums/web-locale';
import { ThumborFunction } from '@/filters/thumbor';

const Language = namespace('language');

@Component({
	name: 'EventBackdrop',
	components: { PictureComp },
})
export default class EventBackdrop extends Vue {
	// offers get created with a domainSessionId in their link out url.
	// this is needed since domainSessionId is not available beforehand, but still the link needs to be created with contexts.
	// changing domainSessionId later will also trigger currentOffers anew.
	protected domainSessionId = '' as string | undefined;

	@Prop() displayOffer: boolean;
	@Prop() watchNowOffer: OfferGraphql;
	@Prop({ required: true }) context: SingleStepContext;

	@Language.State webLocale: WebLocale;
	@Language.Getter country: string;

	get playIcon() {
		return `url(/${ASSETS_DIR}/img/justwatch-sports-icon-play.svg)`;
	}

	get backdropImage() {
		const sport = contextSportIs.esports(this.context) ? 'ESPORTS' : this.context.sportType;
		return (<ThumborFunction>Vue.filter('Thumbor'))({
			url: `/${ASSETS_DIR}/img/sports/jw-sports-backdrop-${sport}-scaled.jpeg`,
			imageType: 'backdrop',
			extension: '.webp',
		});
	}

	get offerClickoutUrl() {
		return new ClickoutUrl(this.watchNowOffer)
			.set('uct_country', this.country)
			.set('uct_buybox', BuyboxParam.Sport)
			.set('sid', this.domainSessionId)
			.set('uct_sport', this.context.sportType)
			.toString();
	}

	get isSponsoredOffer() {
		return SponsoredClickoutsHelper.isSponsoredOfferGraphql(this.watchNowOffer.package.packageId, this.webLocale);
	}

	@Emit('clickOut')
	handleClickOut() {
		const watchNowOffer = this.watchNowOffer;
		return { offer: watchNowOffer, index: undefined };
	}
}
